import type { Location } from 'react-router';
import { ROUTES } from './constants';

export type GuideNavigationState = { guideReturnTo?: unknown };

export function guideLinkState(location: Pick<Location, 'pathname' | 'search' | 'hash'>): GuideNavigationState {
  return { guideReturnTo: `${location.pathname}${location.search}${location.hash}` };
}

export function getGuideReturnTo(location: Pick<Location, 'hash' | 'state'>): string {
  const candidate = (location.state as GuideNavigationState | null)?.guideReturnTo;
  if (typeof candidate === 'string' && candidate.startsWith('/') && !candidate.startsWith('//') && !candidate.startsWith(ROUTES.GUIDE)) {
    return candidate;
  }

  if (location.hash === '#register') return ROUTES.REGISTER;
  if (location.hash === '#login') return ROUTES.LOGIN;
  return ROUTES.WATCH;
}
